/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2020, 2021
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
define([
	'../../../visualizations/renderer/sequence/BaseTask'
], function(
	BaseTask
) {

	/**
	 * Performance task responsible for adding data query params specific to the IPA feature
	 */
	class PerformanceIPATask extends BaseTask {
		process(renderContext) {
			const performanceFeature = this.content.getFeature('Performance');
			if (performanceFeature && performanceFeature.isIPAActive()) {
				if (!renderContext.extraInfo) {
					renderContext.extraInfo = {};
				}
				renderContext.extraInfo.dataQueryParams = {
					...(renderContext.extraInfo.dataQueryParams || {}),
					ipaMode: true
				};
			}

			return Promise.resolve();
		}
	}

	class PerformanceIPATaskProvider {
		constructor({ features }) {
			features.RenderSequence.registerRenderStepProvider(this);
		}
		getRenderStepList() {
			return [{
				id: 'ipa',
				dependencies:[],
				blocks:['data'],
				throwOnError: true,
				module: PerformanceIPATask
			}];
		}
	}

	return PerformanceIPATaskProvider;
});